import { ReactNode } from "react";
import { Container } from "../../elements/Container";
import { styles } from "./VinSearchComponent.style";
import { useSettings } from "./utils/useSettings";
import { LinkButton } from "../../elements/LinkButton";
import { ButtonVariants } from "../../shared/Button/Button.types";

export interface VinSearchComponentProps {
  header: string;
  subtitle: string;
  children: ReactNode;
  bottomSubtitle: ReactNode;
  componentType: string;
  bottomSubtitleUrl: string;
  openModal: (event: any) => void;
}

export const VinSearchComponent = (props: VinSearchComponentProps) => {
  const { header, subtitle, children, bottomSubtitle, componentType, bottomSubtitleUrl, openModal } = props;
  const { isMainHeading, isModalStyled, hasBlueBackground } = useSettings(componentType);
  return (
    <div className={styles.root(hasBlueBackground)}>
      <Container>
        {isMainHeading ? (
          <h1 className={styles.mainHeading()}>{header}</h1>
        ) : (
          <h3 className={styles.secondHeading()}>{header}</h3>
        )}
        {!!subtitle && <p>{subtitle} </p>}
        <div className={styles.wrapper()}>{children}</div>
        {!!bottomSubtitle && isModalStyled ? (
          <div className={styles.linkWrapper()}>
            <LinkButton
              variant={ButtonVariants.Text}
              onClick={bottomSubtitleUrl ? undefined : openModal}
              href={bottomSubtitleUrl ? bottomSubtitleUrl : ""}
            >
              {bottomSubtitle}
            </LinkButton>
          </div>
        ) : (
          <p>{bottomSubtitle}</p>
        )}
      </Container>
    </div>
  );
};
